import { useState } from 'react';
import {
  Icon,
  ICONS,
  Modal,
  TextInput,
  EmptyContainer,
  EMPTY_ILLUSTRATIONS,
  PLATFORM_THEME_COLORS,
  showNotification,
  NOTIFICATION_TYPE,
} from '@thinknet-gmbh/platform-common-ui';
import { useTranslation } from 'react-i18next';
import { DOCUMENT_PLACEHOLDERS } from '@thinknet-gmbh/platform-common';

import {
  HeaderWrapper,
  PlaceholdersItem,
  PlaceholdersWrapper,
} from './placeholder-list.styles';

const PLACEHOLDERS_LIST = Object.values(DOCUMENT_PLACEHOLDERS).map(
  placeholder => `{{${placeholder}}}`
);

const PlaceholderListModal = ({ onClose }: { onClose: () => void }) => {
  const { t } = useTranslation(['common', 'settings']);
  const [placeholders, setPlaceholders] = useState<string[]>(PLACEHOLDERS_LIST);
  const onPlaceholderChange = (event: any) => {
    const { value: searchValue } = event.currentTarget;

    if (searchValue) {
      const searchRegex = new RegExp(`.*${searchValue}.*`, 'i');
      const placeholdersToView = PLACEHOLDERS_LIST.filter(placeholder =>
        searchRegex.test(placeholder)
      );

      return setPlaceholders(placeholdersToView);
    }

    return setPlaceholders(PLACEHOLDERS_LIST);
  };

  const handleCopy = (item: string) => () => {
    navigator.clipboard.writeText(item);
    showNotification({
      type: NOTIFICATION_TYPE.success,
      message: 'Copied',
    });
  };

  const parsePlaceholders = (str: string) => {
    const cleanedInput = str.replace(/{{|}}/g, '');
    return t(`settings:documents.placeholderList.${cleanedInput}`)
  };

  return (
    <Modal
      isOpened
      onClose={onClose}
      title={t('settings:documents.buttons.placeholderList')}
      modalWidth={1200}
    >
      <HeaderWrapper>
        <TextInput
          type="text"
          onChange={onPlaceholderChange}
          prefix={
            <Icon
              icon={ICONS.search}
              color={PLATFORM_THEME_COLORS.primary.grey}
              size={18}
              rightMargin={false}
            />
          }
          placeholder={t('settings:documents.labels.startTyping')}
        />
      </HeaderWrapper>
      <PlaceholdersWrapper>
        {placeholders.map(placeholder => (
          <PlaceholdersItem key={placeholder}>
            <span>{parsePlaceholders(placeholder)}</span>
            <div>
              {placeholder}
              <button onClick={handleCopy(placeholder)} aria-label={placeholder}>
                <Icon
                  icon={ICONS.copySolid}
                  color={PLATFORM_THEME_COLORS.grayVariations.murky}
                  size={16}
                  rightMargin={false}
                />
              </button>
            </div>
          </PlaceholdersItem>
        ))}
      </PlaceholdersWrapper>
      {!placeholders.length && (
        <EmptyContainer
          illustration={EMPTY_ILLUSTRATIONS.seo}
          emptyTitle={t('common:emptySearch.title')}
          contentText={t('common:emptySearch.subTitle')}
        />
      )}
    </Modal>
  );
};

export default PlaceholderListModal;
